import {AppState} from "../../Redux/Types";
import {connect} from "react-redux";
import {bindActionCreators} from "redux";
import Welcome from "../Presentation/Welcome/Welcome";
import {setUserEmail} from "../../Redux/Actions";

function mapStateToProps(state: AppState) {
    return {
        user: state.user,
    }
}

function mapDispatchToProps(dispatch: any) {
    return bindActionCreators({
        setUserEmail,
    }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Welcome);